import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './MandatoryField.module.scss'

interface IProps {
  value: string | number | null
  isShow: boolean
}

export const MandatoryField = ({ value, isShow }: IProps) => {
  const isShowMandatorySign = useMemo(
    () => isShow && (value === null || (!value && Number(value) !== 0)),
    [isShow, value]
  )

  return (
    <div className={styles.mandatory}>
      {isShowMandatorySign && <Translation text="jbp-planning-mandatory" span actionsInside />}
    </div>
  )
}
